module.exports = [{
    cateid: null,
    cateName: '全部',
    subName: '都在这里'
},{
    cateid: '111|112|114',
    cateName: '女生',
    subName: '美容/鞋服/珠宝'
}, {
    cateid: '109',
    cateName: '母婴',
    subName: '母婴用品/玩具'
}, {
    cateid: '101|102|103',
    cateName: '数码',
    subName: '手机/电脑/数码'
}, {
    cateid: '107|108',
    cateName: '居家',
    subName: '家具/家居/家电'
}, {
    cateid: '105|106',
    cateName: '有车族',
    subName: '代步工具/车载'
}, {
    cateid: '110',
    cateName: '运动',
    subName: '运动/户外'
}, {
    cateid: '113|115|116',
    cateName: '文青',
    subName: '图书/票务/乐器'
}, {
    cateid: '117|118|100|104',
    cateName: '大杂烩',
    subName: '文具/古玩/宠物'
}];


/** WEBPACK FOOTER **
 ** ./src/components/Home/menuList.js
 **/